var _circle, _circle2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#0098EA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_119_256",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 24,
    height: 24
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 11.5,
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_119_256)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 1.0293,
    width: 8,
    height: 8,
    transform: "rotate(45 18 1.0293)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.657,
    y: 6.68604,
    width: 8,
    height: 8,
    transform: "rotate(45 23.657 6.68604)",
    fill: "#E1F5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.3137,
    y: 12.3428,
    width: 8,
    height: 8,
    transform: "rotate(45 29.3137 12.3428)",
    fill: "#B2E1F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.657,
    y: 18,
    width: 8,
    height: 8,
    transform: "rotate(45 23.657 18)",
    fill: "#E1F5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12.3428,
    width: 8,
    height: 8,
    transform: "rotate(45 18 12.3428)",
    fill: "#0098EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.3433,
    y: 6.68604,
    width: 8,
    height: 8,
    transform: "rotate(45 12.3433 6.68604)",
    fill: "#E1F5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.68628,
    y: 12.3428,
    width: 8,
    height: 8,
    transform: "rotate(45 6.68628 12.3428)",
    fill: "#B2E1F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.3433,
    y: 18,
    width: 8,
    height: 8,
    transform: "rotate(45 12.3433 18)",
    fill: "#E1F5FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 23.6567,
    width: 8,
    height: 8,
    transform: "rotate(45 18 23.6567)",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e2fb8e28c6889a34f4d082ff803bfc39.svg";
export { ForwardRef as ReactComponent };